import { useTranslation } from 'react-i18next';
import { PageHeading, PageSubHeading } from '@/typography/Typography';
import { ViewSwitch } from '@/components/shared/ViewSwitch';
import { TipsListPage } from './TipsListPage';
import { useMemo, useState } from 'react';
import { TipsReconciliationPage } from './TipsReconciliationPage';
import { TipsActivePayrollPage } from './TipsActivePayrollPage';
import {
    useTipsHistory,
    useCurrentCompanyDetails
} from '@/services/paymentsQuery';
import { Box, Stack } from '@mui/material';
import { TipsModeChip } from '@/components/shared/TipsModeChip';

export const TipsAccountsPage = () => {
    const { t } = useTranslation();
    const [tabIndex, setTabIndex] = useState<number | null>(null);
    const { data: tipsHistoryData } = useTipsHistory(0, 16, []);
    const { data: companyData } = useCurrentCompanyDetails();

    const isValidationMode =
        companyData?.data?.enableTips === true &&
        companyData?.data?.enabledTipsInBalance === false;

    const viewSwitchItems = useMemo(() => {
        let list = [
            {
                primaryText: t('daily_settlement'),
                badgeText: tipsHistoryData?.data?.total?.toString() ?? '',
                route: 'tips-settlement/page/0',
                path: 'tips-settlement/page/:pageNumber',
                overrideTestPath: 'tips-settlement/page',
                routeComponent: <TipsListPage />
            },
            {
                primaryText: t('active_payroll'),
                badgeText: '',
                route: 'tips-active-payroll',
                routeComponent: <TipsActivePayrollPage />
            },
            {
                primaryText: t('reconciliation'),
                badgeText: '',
                route: 'tips-reconciliation',
                routeComponent: <TipsReconciliationPage />
            }
        ];
        return list;
    }, [tipsHistoryData?.data?.total]);

    return (
        <div>
            <Stack direction="row" alignItems="center" gap={1.5} mb={0.5}>
                <PageHeading>{t('InstaTips')}</PageHeading>
                {isValidationMode && <TipsModeChip mode="ValidationMode" />}
            </Stack>
            <PageSubHeading>{t('tips.tips_page_subtitle')}</PageSubHeading>
            <ViewSwitch
                itemList={viewSwitchItems}
                setSelectedIndex={setTabIndex}
                selectedIndex={tabIndex}
            />
        </div>
    );
};
